export default "__VITE_ASSET__a17e644a__"